'use client';

import RefreshIcon from '@mui/icons-material/Refresh';
import { useTranslate } from '@tolgee/react';

export default function Generating({ className }) {
  const { t } = useTranslate();
  return (
    <div
      className={`flex min-h-[3rem] w-fit items-center rounded-[1.5rem] bg-n-8/80 px-3 py-2 md:px-6 md:py-3 ${className || ''} text-sm md:text-base whitespace-nowrap`}
    >
      <RefreshIcon className="mr-3 text-color-secondary" sx={{ fontSize: { xs: 16, md: 20 } }} />
      {t('provider_page.hero.widget')}
    </div>
  );
}
